module.exports = __webpack_public_path__ + "static/media/instagram-background.0dd33228.svg";